function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M37.811 28.901c-15.584 20.226-15.335 46.835-13.263 57.61L19.16 88.17c-9.284-29.51 6.217-49.736 16.993-61.755l1.658 2.486z",
  fill: "url(#icon1_svg__paint0_linear)"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M36.153 26C15.015 52.526 13.523 62.804 19.16 88.999M36.153 26c21.138 26.526 22.63 36.804 16.993 62.999",
  stroke: "#fff",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M1 104.334c7.326-11.27 20.331-18.766 35.153-18.766s27.827 7.495 35.153 18.766",
  stroke: "#fff",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M2.678 106.406a31.5 31.5 0 01-1.34-9.118c0-8.753 3.57-16.673 9.334-22.381M69.844 106.406a31.499 31.499 0 001.34-9.118c0-8.753-3.57-16.673-9.334-22.381",
  stroke: "#fff",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  r: 3.974,
  transform: "matrix(1 0 0 -1 36.153 51.697)",
  stroke: "#fff",
  strokeWidth: 2
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M39.13 109.722a3.315 3.315 0 01-6.63 0V96.459a3.316 3.316 0 116.63 0v13.263z",
  fill: "url(#icon1_svg__paint1_linear)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M48.353 109.903a3.316 3.316 0 01-6.63 0v-8.289a3.316 3.316 0 116.63 0v8.289z",
  fill: "url(#icon1_svg__paint2_linear)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M28.46 109.903a3.316 3.316 0 01-6.632 0v-8.289a3.316 3.316 0 116.631 0v8.289z",
  fill: "url(#icon1_svg__paint3_linear)"
});

var _ref9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "icon1_svg__paint0_linear",
  x1: 27.063,
  y1: 100.178,
  x2: 27.065,
  y2: 16.122,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.917,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "icon1_svg__paint1_linear",
  x1: 36.125,
  y1: 91.796,
  x2: 36.125,
  y2: 114.453,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.917,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "icon1_svg__paint2_linear",
  x1: 45.348,
  y1: 97.288,
  x2: 45.348,
  y2: 114.281,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.917,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "icon1_svg__paint3_linear",
  x1: 25.453,
  y1: 97.288,
  x2: 25.453,
  y2: 114.281,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.917,
  stopColor: "#fff",
  stopOpacity: 0
})));

function SvgIcon1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 140,
    viewBox: "0 0 141 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

export default "data:image/svg+xml;base64,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";
export { SvgIcon1 as ReactComponent };